exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=PT+Sans:400,700);", ""]);

// module
exports.push([module.id, "body{font-family:PT Sans,Helvetica,sans-serif;font-weight:400}body,h1,h2,h3,h4,h5{color:#606062}a{color:#6492dd;text-decoration:none}a:hover{text-decoration:underline}.ProfileCard__profileCard___1EFwg{grid-area:userInfo;background-color:#dee6f2;padding:1.75rem 2.5rem;text-align:center}.ProfileCard__image___3S3po{border-radius:40px;width:80px;height:80px}.ProfileCard__name___1r2yU{display:block;font-weight:700;font-size:1.3em;padding-top:.8em}.ProfileCard__location___3vxxW{display:block;font-size:.9em;padding-top:.2em}.ProfileCard__caption___1RmyY{display:block;font-size:.9em;padding-top:1em;word-wrap:break-word;overflow-wrap:break-word}", ""]);

// exports
exports.locals = {
	"profileCard": "ProfileCard__profileCard___1EFwg",
	"image": "ProfileCard__image___3S3po",
	"name": "ProfileCard__name___1r2yU",
	"location": "ProfileCard__location___3vxxW",
	"caption": "ProfileCard__caption___1RmyY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"sourceMap":true,"plugins":[null]}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/ProfileCard.less
// module id = ./node_modules/css-loader/index.js?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":true,"plugins":[null]}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/ProfileCard.less
// module chunks = 0